/**
 * Card drag + resize handlers. Local-only overrides — the CRDT
 * write-back of canvas_meta on mouseup (debounced, Awareness preview)
 * is the Phase 5c follow-up.
 */

import type React from 'react'

export interface CardOverride {
  x?: number
  y?: number
  width?: number
  height?: number
}

export type CardOverrides = Record<string, CardOverride>

export type SetCardOverrides = React.Dispatch<
  React.SetStateAction<CardOverrides>
>

export const MIN_CARD_WIDTH = 140
export const MIN_CARD_HEIGHT = 72

export function beginDrag(
  e: React.MouseEvent,
  id: string,
  start: { x: number; y: number },
  setOverrides: SetCardOverrides,
) {
  e.stopPropagation()
  const startMouseX = e.clientX
  const startMouseY = e.clientY

  const onMove = (ev: MouseEvent) => {
    const dx = ev.clientX - startMouseX
    const dy = ev.clientY - startMouseY
    setOverrides((prev) => ({
      ...prev,
      [id]: { ...prev[id], x: start.x + dx, y: start.y + dy },
    }))
  }
  const onUp = () => {
    window.removeEventListener('mousemove', onMove)
    window.removeEventListener('mouseup', onUp)
    // TODO Phase 5c: commit canvas_meta to CRDT here.
  }
  window.addEventListener('mousemove', onMove)
  window.addEventListener('mouseup', onUp)
}

export function beginResize(
  e: React.MouseEvent,
  id: string,
  start: { width: number; height: number },
  setOverrides: SetCardOverrides,
) {
  e.stopPropagation()
  e.preventDefault()
  const startMouseX = e.clientX
  const startMouseY = e.clientY

  const onMove = (ev: MouseEvent) => {
    const dx = ev.clientX - startMouseX
    const dy = ev.clientY - startMouseY
    setOverrides((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        width: Math.max(MIN_CARD_WIDTH, start.width + dx),
        height: Math.max(MIN_CARD_HEIGHT, start.height + dy),
      },
    }))
  }
  const onUp = () => {
    window.removeEventListener('mousemove', onMove)
    window.removeEventListener('mouseup', onUp)
  }
  window.addEventListener('mousemove', onMove)
  window.addEventListener('mouseup', onUp)
}
